import {
  MapIcon,
  MapIconDefaultScale,
  MapIconName,
  MapIconScale,
} from '../../../../../../../components/Maps/components/MapIcon';
import { Text } from '../../../../../../../components/Text/Text';
import { ToggleSwitch } from '../../../../../../../components/ToggleSwitch/ToggleSwitch';
import { useExplore } from '../../../../../context/ExploreContext';

interface IProps {
  title: string;
  description?: string;
  icon?: MapIconName;
  isActive: boolean;
  onClick: () => void;
  proOptions?: { proOnly: boolean; proCTA: () => void };
  className?: string;
  mapIconScale?: MapIconScale;
}

export const MapLayerSwitch = ({
  title,
  description = '',
  icon,
  isActive,
  onClick,
  proOptions,
  className = '',
  mapIconScale = MapIconDefaultScale,
}: IProps) => {
  const hasDescription = description && description.length > 0;
  const { exploreQueryParams } = useExplore();

  return (
    <div className={`bg-sea-foam my-2 flex min-h-[56px] rounded-md px-1 ${className}`}>
      {icon && (
        <div className="ml-3 flex min-w-fit items-center justify-center">
          <MapIcon
            alt={title}
            name={icon}
            scale={mapIconScale}
            mapStyle={exploreQueryParams.mapStyle}
          />
        </div>
      )}
      <div
        className={`${
          hasDescription ? 'flex-col' : 'flex items-center'
        } bg-sea-foam items-start p-3`}
      >
        <Text variant="sm" className="mb-0 font-semibold">
          {title}
        </Text>
        {hasDescription && (
          <Text variant="sm" className="mb-0">
            {description}
          </Text>
        )}
      </div>
      <div className="bg-sea-foam ml-auto flex items-center pr-2">
        <ToggleSwitch
          isActive={isActive}
          onClick={() => {
            onClick();
          }}
          proOptions={proOptions}
        />
      </div>
    </div>
  );
};
